import updateSubAPI from '@api/routes/myvca-api/update-subscription';
import updateAddressAPI from '@api/routes/myvca-api/update-subscription-address';
import updatePaymentAPI from '@api/routes/myvca-api/update-subscription-payment';
import ApiService from '@api/api-service';

const DATA_PAYMENT_ID = 'payment-id';
const DATA_VETSOURCE_ADDRESS_ID = 'vetsource-address-id';

export const dataProperties = {
    paymentId: DATA_PAYMENT_ID,
    vetsourceAddressId: DATA_VETSOURCE_ADDRESS_ID
};

var VCA = VCA || {};

VCA.ManageSubscriptions = (function ($) {

    var ui = {};

    function cacheUI() {
        ui.$sectionwrapper = $('.js-sub-section');
        ui.$editBtn = $('.js-edit-info');
        ui.$cancelBtn = $('.js-cancel-edits');
        ui.$submitBtn = $('.js-submit-edits');
        ui.$changePasswordBtn = $('.js-change-password');
        ui.token = $('input[name="__RequestVerificationToken"]').val();
        ui.dataSourcedId = window.datasourceId;
        ui.loader = $('.ajax-loader');
    }

    function init() {
        if ($('.subscription-details').length <= 0) {
            return;
        }
        cacheUI();
        bindEditItem();
        bindCancelItem();
        bindCancelSubscriptionClick();
        bindReasonChangeItem();
        bindReasonMessage();
        bindupdateClick();
        bindCancelSubscriptionComfirmClick();
    }

    function bindEditItem() {
        ui.$sectionwrapper.on('click', '.js-edit-info', function (e) {
            e.preventDefault();
            parent = $(this).closest('.js-sub-section');
            parent.find('.js-sub-details-info').hide();
            parent.find('.js-sub-details-edit').show();
            $('.js-edit-info').addClass('disabled');
            $('[data-error]').hide();
            var tomorrow = new Date();
            tomorrow.setDate(tomorrow.getDate() + 1);
            let editSeciton = $(this).data('edit');
            if (editSeciton == 'details') {
                let currentDate = $('#shipmentdate').data('input');
                $('.js-shipment-date').flatpickr({
                    minDate: tomorrow,
                    altInput: true,
                    altFormat: "n/d/y",
                    dateFormat: "n/d/y",
                    disableMobile: true,
                    defaultDate: currentDate
                });
            }
            if(editSeciton == 'address') {
            //   let addressId = $('div[data-info="address"]').attr('data-addressId');
               parent.find('.select-box__select').prop("selectedIndex", 1);
            }
            if(editSeciton == 'payment') {
             //   let paymentId = $('div[data-info="payment"]').attr('data-paymentId');
                parent.find('.select-box__select').prop("selectedIndex", 1);
             }
        });
    }

    function bindCancelItem() {
        ui.$sectionwrapper.on('click', '.js-cancel-edits', function (e) {
            e.preventDefault();
            parent = $(this).closest('.js-sub-section');
            parent.find('.js-sub-details-edit').hide();
            parent.find('.js-sub-details-info').show();
            $('.js-edit-info').removeClass('disabled');
        });
    }

    function bindupdateClick() {
        ui.$sectionwrapper.on('click', '.js-submit-edits', function (evt) {
            evt.preventDefault();

            const $targetEl = $(evt.target);
            const section = $(this).data('edit');

            switch (section) {
                case 'details':
                    if (!$('.js-shipment-date').val()) return;

                    updateDetails();
                    break;
                case 'address':
                    updateAddress($targetEl);
                    break;
                case 'payment':
                    updatePayment($targetEl);
                    break;
            }
        });
    }

    function bindCancelSubscriptionClick() {
        $('.subscription-details').on('click', '.js-cancel-subcription', function (e) {
            e.preventDefault();
            randomizeDropdownList();
            $('#cancel-subscription').modal('show');
        });
    }

    function randomizeDropdownList() {
        let selector = $('.select-box__select.js-cancel-reason option').not(':first');
        for(var i = 0; i < selector.length; i++){
            var target = Math.floor(Math.random() * selector.length -1) + 1;
            var target2 = Math.floor(Math.random() * selector.length -1) +1;
            selector.eq(target).before(selector.eq(target2));
        }
    }

    function bindReasonChangeItem() {
        $('#cancel-subscription').on('change', '.js-cancel-reason', function (e) {
            e.preventDefault();
            let value = $(this).val().toLowerCase();
            if (value == 'other') {
                $('.js-cancelmessage').show();
                $('.js-comfrim-cancel').addClass('disabled');
            } else if (value == '') {
                $('.js-cancelmessage').hide();
                $('.js-cancelmessage').val('');
                $('.js-comfrim-cancel').addClass('disabled');
            } else {
                $('.js-cancelmessage').hide();
                $('.js-cancelmessage').val('');
                $('.js-comfrim-cancel').removeClass('disabled');
            }
        });
    }

    function bindCancelSubscriptionComfirmClick() {
        $('#cancel-subscription').on('click', '.js-comfrim-cancel', function (e) {
            e.preventDefault();
            $('#cancel-subscription').modal('hide');

            let vetsourceid = $(this).data('vetsourceid');
            cancelSubscription(vetsourceid);
        });
    }

    function bindReasonMessage() {
        $('#cancel-subscription').on('keyup change', '.js-cancelmessage', function (e) {
            if ($(this).val().length != '') {
                $('.js-comfrim-cancel').removeClass('disabled');
            } else {
                $('.js-comfrim-cancel').addClass('disabled');
            }
        });
    }

    async function updateDetails() {
        ui.loader.show();
        let vetid = $('[data-vetsourceid]').data('vetsourceid');
        let next = $('.js-shipment-date').val();
        let frequency = $('.js-frequency-select').find('option:selected').data('id');

        var params = {
            "Id": vetid,
            "Frequency": frequency,
            "NextShipmentDate": next
        };
        //console.log('next', params);
        const { success, data, error } = await updateSubAPI.post(params);
        if (!success || !data) {
            console.log('failed', error);
            $('[data-error="details"]').text(error).show();
            $('[data-form="details"]').hide();
            $('[data-info="details"]').show();
            $('.js-edit-info').removeClass('disabled');
            ui.loader.hide();
            return;
        }
        else {
            location.reload();
            ui.loader.hide();
        }

    };


    async function updateAddress($targetEl) {
        ui.loader.show();

        const vetid = $('[data-vetsourceid]').data('vetsourceid');
        const addressId = $targetEl.data(DATA_VETSOURCE_ADDRESS_ID);

        const params = {
            Id: vetid,
            VetSourceAddressId: addressId
        };

        //console.log('next', params);

        const { success, data, error } = await updateAddressAPI.post(params);

        if(success && data) {
            location.reload();
        } else {
            console.log('failed', error);
            $('[data-error="address"]').text(error).show();
            $('[data-form="address"]').hide();
            $('[data-info="address"]').show();
            $('.js-edit-info').removeClass('disabled');
        }

        ui.loader.hide();
    };

    async function updatePayment($targetEl) {
        ui.loader.show();

        const vetid = $('[data-vetsourceid]').data('vetsourceid');
        const paymentId = $targetEl.data(DATA_PAYMENT_ID);

        const params = {
            "Id": vetid,
            "PaymentId": paymentId
        };

        //console.log('next', params);

        const { success, data, error } = await updatePaymentAPI.post(params);

        if(success && data) {
            location.reload();
        } else {
            console.log('failed', error);
            $('[data-error="payment"]').text(error).show();
            $('[data-form="payment"]').hide();
            $('[data-info="payment"]').show();
            $('.js-edit-info').removeClass('disabled');
        }

        ui.loader.hide();
    };

    async function cancelSubscription(vetsourceid) {
        let reason = $('.js-cancel-reason').val();
        let otherMessage = $('.js-cancelmessage').val();
        let params = {
            "Id": vetsourceid,
            "Reason": reason,
            "OtherDetails": otherMessage
        }

        const url = '/myvca-api/subscriptions/delete';
        let api = new ApiService(url);
        const { data, success, error } = await api.post(params);

        if (!success || !data) {
            alert(`Sorry, There was an error. ${error}`);
            console.log(`Status: ${error}`);
        } else {
            var redirect = $('#redirectlink').val();
            window.location.assign(redirect);
            ui.loader.hide();
        }
    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    VCA.ManageSubscriptions.init();
});